export default __webpack_public_path__ + "static/media/newProject.0a655c1c.png";